import { render, staticRenderFns } from "./resources-list.vue?vue&type=template&id=3a333560"
import script from "./resources-list.vue?vue&type=script&lang=js"
export * from "./resources-list.vue?vue&type=script&lang=js"
import style0 from "./resources-list.vue?vue&type=style&index=0&id=3a333560&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports